// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------
import { handleActions } from 'redux-actions';
import {
    POST_ADD_AAD_USER_SUCCESS,
    POST_ADD_BULK_AAD_USERS_SUCCESS,
    CLEAR_AAD_USER_MESSAGE,
    CLEAR_BULK_USERS_MESSAGE,
} from './actions';

export const INITIAL_STATE: {
    addAadUser: any;
    addBulkAadUsers: any;
} = {
    addAadUser: undefined,
    addBulkAadUsers: [],
};

export type ManageAadUsersStoreType = Readonly<typeof INITIAL_STATE>;

export default handleActions(
    {
        [POST_ADD_AAD_USER_SUCCESS]: _postAddAadUser,
        [POST_ADD_BULK_AAD_USERS_SUCCESS]: _postAddBulkAadUsers,
        [CLEAR_AAD_USER_MESSAGE]: _postAddAadUser,
        [CLEAR_BULK_USERS_MESSAGE]: _postAddBulkAadUsers,
    },
    INITIAL_STATE
);

function _postAddAadUser(
    state: ManageAadUsersStoreType,
    { payload }: { payload: any }
): ManageAadUsersStoreType {
    return { ...state, addAadUser: payload };
}

function _postAddBulkAadUsers(
    state: ManageAadUsersStoreType,
    { payload }: { payload: any }
): ManageAadUsersStoreType {
    return { ...state, addBulkAadUsers: payload };
}
